<script>
  export let nftImageUrl; // Accept an image URL as a prop

  let showMarketplace = false;

  function toggleMarketplace() {
    showMarketplace = !showMarketplace;
  }
</script>

<!-- NFT Image acts as a button -->
<img src={nftImageUrl} alt="Open Marketplace" class="nft-button" on:click={toggleMarketplace} />

<!-- Iframe Overlay -->
{#if showMarketplace}
  <div class="iframe-overlay">
    <iframe src="https://0x888.x.rarible.com/" frameborder="0"></iframe>
    <button on:click={toggleMarketplace} class="close-btn">Close</button>
  </div>
{/if}

<style>
  .nft-button {
    /* Adjust the styles to fit your sidebar design */
    display: block;
    width: 100%;
    cursor: pointer;
    margin-bottom: 1rem;
  }
  .iframe-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000; /* Ensure it's above other content */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .iframe-overlay iframe {
    width: 90%; /* Adjust based on preference */
    height: 90%; /* Adjust based on preference */
    border: none;
  }
  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
</style>
